import connector from "@/repository/connector";

export default {
  async send(payload = {}) {
    return connector.requestWithFallback(
      () => connector.connector.post("alerts/send_alert/", payload),
    );
  },
};
